import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Charts from '../../common/Charts/Charts';
import { processCompetitionColumnChartData, getChartLegendColumnWidth } from '../../../util/SalesCatalystUtils';
import { SC_COMPETITOR_COLUMN_CHART_HEADING } from '../../../messages/messages';
import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';
import { SC_COMPARE_CHART_COLORS } from '../../../constants';

class SalesCatalystCompetitionColumnChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: processCompetitionColumnChartData(this.props.studyInfo, this.props.data,
        this.props.baseInfo !== undefined ? this.props.baseInfo.label : undefined,
        this.props.dataSelection !== undefined ?
          this.props.dataSelection.targetMarket[0].label : undefined, this.props.color),
      dataSelectionInfo: this.props.dataSelection,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data, dataSelection, baseInfo } = this.props;
    if (data !== nextProps.data) {
      this.setState({
        chartData: processCompetitionColumnChartData(this.props.studyInfo, nextProps.data,
          baseInfo !== undefined ? baseInfo.label : undefined,
          dataSelection !== undefined ? dataSelection.targetMarket[0].label : undefined,
          this.props.color),
        dataSelectionInfo: dataSelection,
      });
    }
  }

  render() {
    const { chartData } = this.state;
    return (
      <div className="sc-competition-block-section">
        <div className="text-align-center margin-bottom-15 clearfix">
          <h3 className="section-heading">{SC_COMPETITOR_COLUMN_CHART_HEADING}</h3>
        </div>
        <div className="row margin-left-0 margin-right-0 margin-top-20">
          <div>
            <Charts
              config={chartData}
            />
          </div>
          <div className="sc-compare-clmn-chart-legend">
            <div className="row">
              <div className="small-3 medium-3 large-3 columns">&nbsp;</div>
              <div className="small-3 medium-3 large-3 columns">
                <span className="cs_column_chart_indicator-icon" style={{ background: 'grey' }}>&nbsp;</span>
                <span className="cs_column_chart_indicator">{`Share of Base`}&nbsp;</span>
              </div>
              <div className="small-3 medium-3 large-3 columns">
                <span className="cs_column_chart_indicator-icon">&nbsp;</span>
                <span className="cs_column_chart_indicator">{`Share of Target Market`}&nbsp;</span>
              </div>
              <div className="small-3 medium-3 large-3 columns">&nbsp;</div>
            </div>
          </div>
          <div className="row">&nbsp;</div>
        </div>
        <SalesCatalystSectionBottom asteriskInfo />
      </div>
    );
  }
}

SalesCatalystCompetitionColumnChart.propTypes = {
  data: PropTypes.shape({}),
  dataSelection: PropTypes.shape({}),
  baseInfo: PropTypes.shape({}),
  studyInfo: PropTypes.shape({})
};

export default SalesCatalystCompetitionColumnChart;

